import SVG from './SVG'

export const PenSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="pen-tool">
        <path
          fillRule="evenodd"
          d="M2.235 1.028a1 1 0 00-1.207 1.207l3.5 14.5a1 1 0 00.776.746l5.765 1.153a1 1 0 00.224 1.073l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414l-3-3a1 1 0 00-1.073-.224L17.48 5.304a1 1 0 00-.746-.776l-14.5-3.5zm11.467 17.685l.005-.006 5-5 .006-.005.287-.288L20.586 15 15 20.586 13.414 19l.288-.287zm3.213-6.042l-1.27-6.349L5.22 3.806l4.487 4.486a3 3 0 11-1.414 1.414L3.805 5.22l2.516 10.425 6.35 1.27 4.242-4.244zM10 11a1 1 0 112 0 1 1 0 01-2 0z"
          className="Union"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
